// ** Next Imports
import Head from 'next/head'
import { useRouter } from 'next/router'

// ** Modules Imports
import { useIntl } from 'react-intl'

// ** Config Imports
import themeConfig from 'src/configs/themeConfig'

const MetadataHeaders = () => {
  const { formatMessage } = useIntl()

  const originHost = `https://${process.env.NEXT_PUBLIC_DOMAIN}`
  const router = useRouter()
  const _pathSliceLength = Math.min.apply(Math, [
    router.asPath.indexOf('?') > 0 ? router.asPath.indexOf('?') : router.asPath.length,
    router.asPath.indexOf('#') > 0 ? router.asPath.indexOf('#') : router.asPath.length
  ])
  const canonicalURL = originHost + router.asPath.substring(0, _pathSliceLength)

  const metaTitle = formatMessage({ id: 'metadata-title-default' }, { name: themeConfig.templateName })
  const metaDescription = formatMessage({ id: 'metadata-description-default' })

  return (
    <Head>
      <title>{metaTitle}</title>
        <meta charSet='utf-8' />
        <meta name='description' content={metaDescription} />

        <meta itemProp='name' content={metaTitle} />
        <meta itemProp='description' content={metaDescription} />
        <meta itemProp='image' content={`${originHost}/images/og-icon-300x300.jpg`} />

        <meta property='og:url' content={originHost} />
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content={process.env.NEXT_PUBLIC_DOMAIN} />
        <meta property='og:title' content={metaTitle} />
        <meta property='og:description' content={metaDescription} />
        <meta property='og:image' content={`${originHost}/images/og-image.jpg`} />
        <meta property='og:image:secure_url' content={`${originHost}/images/og-image.jpg`} />
        <meta property='og:image:width' content='968' />
        <meta property='og:image:height' content='504' />
        <meta property='og:image:type' content='image/jpg' />

        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={metaTitle} />
        <meta name='twitter:description' content={metaDescription} />
        <meta name='twitter:image' content={`${originHost}/images/og-icon-500x500.jpg`} />

        <meta name='keywords' content={`${themeConfig.templateName}, Publishing Platform, Admin, Platform`} />
        <meta name='viewport' content='initial-scale=1, width=device-width' />

        <link rel='apple-touch-icon' sizes='60x60' href={`${originHost}/images/apple-touch-icon-60x60.jpg`} />
        <link rel='apple-touch-icon' sizes='72x72' href={`${originHost}/images/apple-touch-icon-72x72.jpg`} />
        <link rel='apple-touch-icon' sizes='120x120' href={`${originHost}/images/apple-touch-icon-120x120.jpg`} />
        <link rel='apple-touch-icon' sizes='152x152' href={`${originHost}/images/apple-touch-icon-152x152.jpg`} />
        <link rel='apple-touch-icon' sizes='180x180' href={`${originHost}/images/apple-touch-icon-180x180.jpg`} />
        <link rel='icon' href='/images/favicon.png' type='image/png' />
        <link rel='shortcut icon' href={`${originHost}/images/favicon.svg`} type='image/svg+xml' />
        <link rel='canonical' href={canonicalURL} />
    </Head>
  )
}

export default MetadataHeaders
